/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 주문 정보 조회 응답
 * @export
 * @interface OrderInfoResponse
 */
export interface OrderInfoResponse {
    /**
     * 성공 여부
     * @type {boolean}
     * @memberof OrderInfoResponse
     */
    'success': boolean;
    /**
     * 주문 ID
     * @type {string}
     * @memberof OrderInfoResponse
     */
    'orderId'?: string;
    /**
     * 결제 금액
     * @type {string}
     * @memberof OrderInfoResponse
     */
    'amount'?: string;
    /**
     * 상품명
     * @type {string}
     * @memberof OrderInfoResponse
     */
    'goodsName'?: string;
    /**
     * Edusense 강의와 연결된 상품 코드
     * @type {string}
     * @memberof OrderInfoResponse
     */
    'productCode'?: string | null;
    /**
     * 주문 상태
     * @type {string}
     * @memberof OrderInfoResponse
     */
    'status'?: OrderInfoResponseStatusEnum;
    /**
     * 주문한 사용자 ID
     * @type {string}
     * @memberof OrderInfoResponse
     */
    'userId'?: string;
    /**
     * 주문 유형
     * @type {string}
     * @memberof OrderInfoResponse
     */
    'orderType'?: OrderInfoResponseOrderTypeEnum;
    /**
     * 아이템 유형
     * @type {string}
     * @memberof OrderInfoResponse
     */
    'itemType'?: OrderInfoResponseItemTypeEnum;
    /**
     * 주문 생성일시
     * @type {string}
     * @memberof OrderInfoResponse
     */
    'createdAt'?: string;
    /**
     * 응답 메시지
     * @type {string}
     * @memberof OrderInfoResponse
     */
    'message': string;
    /**
     * 오류 코드 (실패 시)
     * @type {string}
     * @memberof OrderInfoResponse
     */
    'errorCode'?: string | null;
}

export const OrderInfoResponseStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;

export type OrderInfoResponseStatusEnum = typeof OrderInfoResponseStatusEnum[keyof typeof OrderInfoResponseStatusEnum];
export const OrderInfoResponseOrderTypeEnum = {
    OneTime: 'ONE_TIME',
    Subscription: 'SUBSCRIPTION'
} as const;

export type OrderInfoResponseOrderTypeEnum = typeof OrderInfoResponseOrderTypeEnum[keyof typeof OrderInfoResponseOrderTypeEnum];
export const OrderInfoResponseItemTypeEnum = {
    Course: 'COURSE',
    SubscriptionPlan: 'SUBSCRIPTION_PLAN'
} as const;

export type OrderInfoResponseItemTypeEnum = typeof OrderInfoResponseItemTypeEnum[keyof typeof OrderInfoResponseItemTypeEnum];


